import { useNavigate } from 'react-router-dom';
import LegalModal, { ls } from '../components/LegalModal';

export default function Transparency() {
  const navigate = useNavigate();
  const close = () => navigate(-1);

  const sections = [
    {
      heading: 'Why This Page Exists',
      content: <p style={{ ...ls.body, fontFamily: '"Instrument Serif", "Cormorant Garamond", serif', fontStyle: 'italic', fontSize: 17, lineHeight: 1.6 }}>
        GhostLight exists because the people who keep the show running deserve a place that isn't trying to extract anything from them. This page explains how we operate, what we spend, and what we've been asked to hand over.
      </p>,
    },
    {
      heading: 'Who Runs This',
      content: <p style={ls.body}>GhostLight is built and maintained by NINJA (ninjasgo.com). There are no outside investors, no board of directors, and no venture capital. The platform is funded entirely by NINJA.</p>,
    },
    {
      heading: 'How We Make Money',
      content: <p style={ls.body}>We don't. GhostLight is free and has no revenue model. There are no ads, no premium tiers, no data sales, and no sponsored content. If that changes, we'll tell you here first.</p>,
    },
    {
      heading: 'What We Spend Money On',
      content: <>
        <ul style={ls.list}>
          <li>Server hosting (single VPS)</li>
          <li>Domain registration and SSL certificates</li>
          <li>Transactional email delivery (Mailjet)</li>
          <li>Development time (NINJA staff)</li>
        </ul>
        <p style={{ ...ls.body, marginTop: 14 }}>There are no paid moderators, no consultants, and no third-party services beyond the above.</p>
      </>,
    },
    {
      heading: 'Data Requests',
      content: <>
        <p style={{ ...ls.body, marginBottom: 14 }}>We will publish this annually. For the current reporting period:</p>
        <ul style={ls.list}>
          <li>Law enforcement requests received: <strong style={ls.strong}>0</strong></li>
          <li>Law enforcement requests complied with: <strong style={ls.strong}>0</strong></li>
          <li>Court orders received: <strong style={ls.strong}>0</strong></li>
          <li>Identity disclosures made for any reason: <strong style={ls.strong}>0</strong></li>
        </ul>
        <p style={{ ...ls.body, marginTop: 14 }}>If we are ever compelled to disclose user identity, we will update this page and, where legally permitted, notify the affected user.</p>
      </>,
    },
    {
      heading: 'Moderation Activity',
      content: <>
        <ul style={ls.list}>
          <li>Posts removed: <strong style={ls.strong}>0</strong></li>
          <li>Warnings issued: <strong style={ls.strong}>0</strong></li>
          <li>Temporary suspensions: <strong style={ls.strong}>0</strong></li>
          <li>Permanent bans: <strong style={ls.strong}>0</strong></li>
          <li>Admin identity access events: <strong style={ls.strong}>0</strong></li>
        </ul>
        <p style={{ ...ls.body, marginTop: 14 }}>All moderation actions are logged with timestamps and reasons. Admin identity access is audited separately.</p>
      </>,
    },
    {
      heading: 'What We Won\'t Do',
      content: <>
        <ul style={ls.list}>
          <li>Sell data or user information to anyone, ever</li>
          <li>Run advertising or sponsored content</li>
          <li>Share aggregate data with researchers without explicit community consent</li>
          <li>Build engagement metrics, streaks, gamification, or algorithmic feeds</li>
          <li>Track what you do outside of GhostLight</li>
        </ul>
        <p style={ls.note}>Questions? Contact terrence@ninjasgo.com</p>
      </>,
    },
  ];

  return <LegalModal title="Transparency" updated="Last updated: April 2026" onClose={close} sections={sections} />;
}
